// extracted by mini-css-extract-plugin
module.exports = {"Container":"ConfirmDialog_Container__PawAw","Actions":"ConfirmDialog_Actions__dsK5t"};